import React from 'react'


const RadioButtonWrapper = ({id, label, children}) => (
    <div className="control-radio-wrapper">
        <label className="control control-radio" htmlFor={id}>{label}
            {children}
            <div className="control_indicator"></div>
        </label>
    </div>
)

export default RadioButtonWrapper